import DataStore from '../../stores/DataStore';
import { ModelDataUpdate } from '../../Events';
import { Report } from '../../model/Report';
import { Building } from '../../model/Building';
import { Unit } from '../../model/Unit';
import { CulturalHeritage } from '../../realty/model/CulturalHeritage';
import { defined, evaluate } from '../../utility/Control';
import { SoilContamination } from '../../realty/model/SoilContamination';
import { SingleHeritage } from '../../realty/model/SingleHeritage';
import { Affair } from '../../model/Affair';

export function init(tag: any): void {
  const onModelDataUpdate = () => {
    map(DataStore.getReport(), tag);
    tag.update();
  };
  tag.on('mount', () => {
    DataStore.addListener(ModelDataUpdate, onModelDataUpdate);
  });
  tag.on('unmount', () => {
    DataStore.removeListener(ModelDataUpdate, onModelDataUpdate);
  });
}

function map(report: Report, tag: any): void {
  let misc: Misc[] = [];
  report.buildings.forEach((building: Building) => {
    misc = misc
      .concat(
        building.units
          .filter((unit: Unit) => defined(unit.unitNumber, unit.address) && !unit.isApproved)
          .map((unit: Unit) => new Misc('Ikke godkjent boenhet', unit.address + ', bolignr ' + unit.unitNumber))
      )
      .concat(
        building.culturalHeritages.map(
          (culturalHeritage: CulturalHeritage) => new Misc('Kulturminne', culturalHeritage.objectName)
        )
      );
  });
  if (defined(report.cadastre)) {
    misc = misc
      .concat(
        report.cadastre.soilContaminations.map(
          (soilContamination: SoilContamination) =>
            new Misc(
              'Grunnforurensning',
              evaluate(soilContamination, 'degreeOfImpactType.text'),
              evaluate(soilContamination, 'links.soilContaminationWebpage.href')
            )
        )
      )
      .concat(
        report.cadastre.singleHeritages.map(
          (singleHeritage: SingleHeritage) =>
            new Misc(
              'Fornminne',
              evaluate(singleHeritage, 'heritageType.text'),
              evaluate(singleHeritage, 'links.singleHeritageWebpage.href')
            )
        )
      );
  }
  misc = misc.concat(
    report.affairs
      .filter((affair: Affair) =>
        defined(evaluate(affair, 'affairDocumentDate.ddmmyyyy'), affair.area, affair.isSubmitee)
      )
      .map(
        (affair: Affair) =>
          new Misc(
            affair.isSubmitee ? 'Fradeling' : 'Sammenslåing',
            affair.area.toString() +
              ' kvm ' +
              (affair.isSubmitee ? 'fradelt fra ' : 'tildelt ') +
              'eiendommen ' +
              affair.affairDocumentDate.ddmmyyyy
          )
      )
  );
  tag.misc = misc;
}

class Misc {
  public type: string;
  public text: string;
  public href: string;

  public constructor(type: string, text: string, href?: string) {
    this.type = type;
    this.text = text;
    this.href = href;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/miscDisplay/MiscDisplayMapper.ts
 **/